import { render, staticRenderFns } from "./PatientMetaData.vue?vue&type=template&id=3e5ae4c4&scoped=true&"
import script from "./PatientMetaData.vue?vue&type=script&lang=js&"
export * from "./PatientMetaData.vue?vue&type=script&lang=js&"
import style0 from "./PatientMetaData.vue?vue&type=style&index=0&id=3e5ae4c4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5ae4c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VFlex,VLayout})
